import { render, staticRenderFns } from "./ProductIntroPC.vue?vue&type=template&id=974182b8&scoped=true"
import script from "./ProductIntroPC.vue?vue&type=script&lang=js"
export * from "./ProductIntroPC.vue?vue&type=script&lang=js"
import style0 from "./ProductIntroPC.vue?vue&type=style&index=0&id=974182b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974182b8",
  null
  
)

export default component.exports